// jshint ignore: start

export default {
  "notificationsPopover": {
    "title": "CGTrader AI Notifications",
    "indicator": {
      "lead": "You'll see",
      "highlight": "an indicator in the top menu",
      "rest": "when your model is generating and when it's ready."
    },
    "emailToggle": "Send me an email when my model is ready",
    "browserToggle": "Activate Browser Notifications",
    "note": "We'll only notify you if you haven't viewed the item in CGTrader AI. You can change your preferences anytime in AI Settings.",
    "save": "Save Preferences",
    "close": "Close"
  },
  "settingsModal": {
    "title": "Settings",
    "tabs": {
      "usage": "Usage",
      "notifications": "Notifications"
    },
    "notificationsTitle": "CGTrader AI Notifications"
  },
  "seo": {
    "imagesTitle": "AI Image Gallery | CGTrader",
    "indexTitle": "3D AI Generator | CGTrader",
    "galleryTitle": "AI 3D Models Generated By Community | CGTrader AI",
    "outputTitle": "{{name}} 3D model | CGTrader AI",
    "imageOutputTitle": "{{name}} | CGTrader AI",
    "indexDescription": "Use text prompts or image references to generate production-ready 3D models for any use case.",
    "galleryDescription": "Explore AI-generated 3D models created by the CGTrader community. Browse, download and create AI 3D assets in FBX, OBJ, STL and other formats.",
    "imagesDescription": "AI Image Gallery - a collection of stunning AI-generated artwork and visuals. Discover and download unique, high-quality images for free.",
    "outputDescription": "AI-generated {{name}} 3D model. Download or remix this asset created by CGTrader AI using text prompts or image references.",
    "imageOutputDescription": "AI-generated image: {{name}}. View and download this image created by CGTrader AI."
  },
  "waitlist": {
    "card": {
      "chip": "Free beta",
      "freeGenerationsHighlight": "5 Free Generations",
      "freeGenerationsSuffix": " in CGTrader AI",
      "noCreditCard": "No credit card is required",
      "gettingStarted": "Great for getting started and trying things out",
      "join": "Join the Waitlist",
      "joining": "Joining...",
      "haveAccessCode": "I have access code",
      "joinError": "Could not join the waitlist. Please try again."
    },
    "accessCode": {
      "label": "Enter the code for free beta access",
      "placeholder": "Enter your code",
      "apply": "Apply",
      "applying": "Applying...",
      "successMessage": "Setting up your access -- we'll notify you once it's ready.",
      "invalidMessage": "Invalid access code. Please try again.",
      "errorMessage": "Could not validate the access code. Please try again."
    },
    "subscriptionBullets": {
      "monthly": "{{monthlyModels}} CGTrader AI generations or Marketplace downloads",
      "editEnhance": "Edit and enhance your own or purchased 3D models",
      "engines": "All top AI engines included: Tripo, Hunyuan, Meshy",
      "allAdvancedFeatures": "Access to all advanced features"
    }
  },
  "bestOnDesktop": {
    "title": "Best on Desktop",
    "description": "CGTrader AI is designed for larger screens. Some editing tools, settings, and 3D previews may not display correctly on mobile. For the best experience, please switch to a desktop."
  },
  "mobileTabBar": {
    "tabs": {
      "generate": "Generate",
      "viewer": "3D Model",
      "enhance": "Enhance"
    }
  },
  "sidebar": {
    "header": {
      "title": "CGTrader AI"
    },
    "linkNav": {
      "generate": "3D Model Generator",
      "communityGallery": "Community Gallery",
      "imageGenerator": "Image Generator",
      "community": "Community",
      "communityThreeDModels": "3D Models",
      "communityImages": "Images"
    },
    "usage": {
      "label": "Usage"
    },
    "settings": {
      "label": "Settings"
    },
    "termsOfService": {
      "label": "Terms of Service"
    },
    "status": {
      "processing": "Processing...",
      "generating": "Generating..."
    },
    "actions": {
      "generateNewModel": "Generate New 3D Model"
    },
    "search": {
      "placeholder": "Search"
    },
    "filtering": {
      "generated": "Generated",
      "purchased": "Purchased",
      "uploaded": "Uploaded",
      "all": "All",
      "favorites": "Favorites",
      "drafts": "Drafts"
    },
    "library": {
      "error": "Failed to load!",
      "emptyState": {
        "text": "Create your first 3D Model and your library will appear here",
        "imagesText": "Create Images and your library will appear here"
      },
      "notFound": {
        "text": "Nothing found"
      },
      "tabs": {
        "models": "3D Models",
        "images": "Images"
      }
    },
    "imageCard": {
      "notifications": {
        "deleteSuccess": "Image deleted successfully.",
        "deleteError": "Failed to delete image. Please try again."
      }
    },
    "modelCard": {
      "draft": "Draft",
      "makePrivate": "Make Private",
      "created": "Created: {{date}}",
      "delete": "Delete",
      "variationsCount": "{{count}} variation",
      "variationsCount_plural": "{{count}} variations"
    },
    "newModelCard": {
      "titleLine1": "Generate New",
      "titleLine2": "3D Model"
    },
    "useModelCard": {
      "titleLine1": "Use your",
      "titleLine2": "3D Model"
    }
  },
  "fullImageEditor": {
    "regionLabel": "Image editor",
    "actions": {
      "delete": "Delete image",
      "generateThreeD": "Generate 3D"
    }
  },
  "imageAssistantPanel": {
    "errors": {
      "downloadFailed": "Download failed. Please try again."
    },
    "title": "AI Image Assistant",
    "actions": {
      "useForThreeDGeneration": "Use for 3D Generation",
      "regenerate": "Regenerate",
      "editImage": "Edit image",
      "modifyImage": "Modify image",
      "download": "Download"
    },
    "createTab": {
      "composer": {
        "send": "Generate New Image",
        "style": "Style",
        "private": "Private",
        "addReferences": "Add references",
        "settings": {
          "trigger": "Generation settings",
          "aspectRatio": "Aspect ratio",
          "variations": "Variations"
        }
      },
      "newImageNote": "Your new prompt will create a new image.",
      "conversation": {
        "emptyPrompt": "What would you like to create?"
      },
      "result": {
        "expand": "Open image in full size",
        "lightbox": "Generated image"
      },
      "generatingState": {
        "label": "Creating your image...",
        "labelMultiple": "Creating your images..."
      },
      "failedState": {
        "title": "Generation failed",
        "text": "Something went wrong while generating your image. Please try again.",
        "retry": "Generate again"
      }
    },
    "editTab": {
      "back": "Back",
      "editFailed": "Edit failed. Please try again.",
      "composer": {
        "placeholder": "Describe what to change (e.g., remove background, simplify details)",
        "placeholderWithImageTools": "Describe what to change (e.g., remove background, upscale, adjust or simplify details)"
      },
      "emptyState": {
        "title": "To edit an image upload, search or create it first",
        "titleWithoutSearch": "To edit an image upload or create it first",
        "subtitle": "Supports text instructions and inpainting"
      },
      "toolbar": {
        "version": "Version {{number}}",
        "originalVersion": "Original",
        "history": "History",
        "removeBackground": "Remove background",
        "upscale": "Upscale",
        "versionKind": {
          "brush": "Brush tool",
          "prompt": "Prompt"
        }
      },
      "promptViewer": {
        "toggleLabel": "Show the prompt used for this version",
        "copyLabel": "Copy prompt",
        "copiedLabel": "Copied",
        "copiedNotification": "Prompt copied to clipboard"
      }
    },
    "searchTab": {
      "searchPlaceholder": "Search reference images",
      "categoriesHeading": "The most searched image categories",
      "loading": "Loading search results...",
      "noResults": {
        "title": "Nothing found",
        "subtitle": "Try creating a reference image using your prompt",
        "create": "Create Image"
      }
    }
  },
  "usageModal": {
    "header": {
      "unlockAiGeneration": "Unlock AI Generation",
      "betaAccessRequested": "Beta access requested",
      "aiUsage": "CGTrader AI Usage"
    },
    "tags": {
      "freePlan": "Free plan",
      "subscription": "CGTrader Subscription"
    },
    "setupHeadline": "You've set everything up - now unlock generation to bring it to life.",
    "terms": {
      "leadDefault": "By continuing using CGTrader AI you agree to the",
      "leadWaitlisted": "By continuing I agree to the",
      "tosLink": "CGTrader AI Terms of Service"
    },
    "extraUsage": {
      "titleWithPrice": "Get {{count}} More Generations for {{price}}",
      "title": "Get {{count}} More Generations",
      "subtitle": "Keep creating without interruptions",
      "cta": "Buy Extra Usage",
      "note": "Extra Usage does not expire or reset monthly."
    },
    "freeBeta": {
      "outOfGenerations": "You're out of free generations",
      "almostOutOfGenerations": "You're almost out of free generations",
      "generationsUsedLabel": "Generations used"
    },
    "freeBetaCard": {
      "successMessage": "You're all set! Start creating your 3D models.",
      "errorMessage": "Could not start your free beta. Please try again.",
      "chip": "Free beta",
      "freeGenerations": "5 Free Generations",
      "inStudio": " in CGTrader AI Studio",
      "noCreditCard": "No credit card required",
      "gettingStarted": "Great for getting started and trying things out",
      "starting": "Starting...",
      "cta": "Start Creating for Free"
    },
    "hasCredits": {
      "creditsLeft": "You have {{count}} credit left",
      "creditsLeft_plural": "You have {{count}} credits left"
    },
    "subscribed": {
      "outOfGenerations": "You're out of generations",
      "monthlyGenerationsUsedLabel": "Monthly Generations used",
      "generationsRatioTooltip": "10 image generations equals 1 regular 3D generation",
      "extraGenerationsUsedLabel": "Extra Generations used",
      "resetDateLabel": "Reset date:",
      "subscriptionSettings": "Go to Subscription Settings"
    },
    "subscriptionCard": {
      "priceUnit": "/ month",
      "cta": "Get Subscription"
    },
    "upgrade": {
      "title": "Upgrade to Start Creating"
    },
    "upgradeCard": {
      "defaultTitle": "Upgrade to Keep Creating",
      "priceUnit": "/ month",
      "cta": "Get Subscription"
    },
    "paidFeature": {
      "title": "Upgrade to Create with More Freedom",
      "advancedFeaturesTitle": "Unlock advanced features:",
      "advancedFeatures": {
        "private": "Keep your models private so only you can view and share them",
        "dccBridge": "DCC Bridge integration for a seamless workflow",
        "export": "Export models in any supported format",
        "multipleModels": "Generate multiple models simultaneously"
      }
    },
    "waitlisted": {
      "onWaitlist": "You're on the waitlist!",
      "copy": "We'll review your request and notify you by email once access is available.",
      "accessCode": "I have access code",
      "upgradeTitle": "Faster access with Subscription"
    }
  },
  "viewerSidebar": {
    "nav": {
      "enhance3dModel": "Enhance 3D Model",
      "remesh": "Remesh",
      "texture": "Texture",
      "segment": "Segment",
      "animate": "Animate",
      "render": "Render",
      "variations": "Variations",
      "history": "History",
      "assist": "Assist",
      "disabledReason": "Generate or upload a model to start editing it",
      "variationsNotOwnerReason": "Variations are available only for your own models"
    },
    "enhance": {
      "common": {
        "done": "Done",
        "processing": "Processing..."
      },
      "remesh": {
        "title": "Remesh",
        "generateLabel": "Remesh",
        "smartLowPoly": "Smart low poly",
        "polycount": {
          "label": "Polycount",
          "low": "Low",
          "medium": "Medium",
          "high": "High"
        },
        "example": {
          "highPoly": "High-poly Mesh",
          "optimized": "Optimized Mesh"
        }
      },
      "texture": {
        "title": "Texture",
        "generateLabel": "Generate Texture",
        "textPlaceholder": "Describe the texture you want to generate for this model",
        "material": {
          "label": "Material",
          "pbr": "PBR",
          "basic": "Basic Material"
        },
        "resolution": {
          "label": "Resolution",
          "2k": "2K",
          "4k": "4K",
          "8k": "8K"
        },
        "preview": {
          "initial": "Initial texture",
          "new": "New texture"
        }
      },
      "segment": {
        "title": "Segmentation",
        "riggedTooltip": "Segmentation is unavailable for rigged models.",
        "placeholderTitle": "Segmentation",
        "placeholderDescription": "Automatically segment your 3D model into editable parts",
        "explodedView": "Exploded View",
        "resetModel": "Reset Model",
        "partList": "Part list",
        "generateLabel": "Start Segmenting",
        "generatingLabel": "Segmenting...",
        "unavailable": {
          "title": "Unavailable for",
          "quad": "Quad models",
          "rigged": "Rigged models"
        }
      },
      "animate": {
        "title": "Animate",
        "description": "Animate your 3D model with intelligent motion controls",
        "rigDescription": "Rig the model to animate",
        "generateLabel": "Animate",
        "searchPlaceholder": "Search animation",
        "noResults": "No animations found"
      },
      "render": {
        "title": "Render 2D",
        "description": "Create high-quality renders of your 3D model in seconds",
        "viewerHint": "Position the 3D Model in the viewer",
        "promptLabel": "Text prompt",
        "promptPlaceholder": "Add details for the final look, e.g. cinematic lighting, soft shadows, studio background",
        "styleLabel": "Style",
        "styleNone": "None",
        "generateLabel": "Render Image",
        "stylePanel": {
          "title": "Select Style",
          "close": "Close style picker",
          "searchPlaceholder": "Search style",
          "categoriesLabel": "Style categories"
        }
      },
      "variations": {
        "title": "Variations",
        "historyTitle": "Variations history",
        "variationPreview": "Variation preview",
        "openRelatedTab": "Open related tab",
        "info": {
          "faces": "{{faces}} faces",
          "prompt": "Text prompt",
          "animation": "Animation"
        },
        "window": {
          "detach": "Detach panel",
          "move": "Move panel",
          "close": "Close panel",
          "resizeTopLeft": "Resize panel from the top-left corner",
          "resizeTopRight": "Resize panel from the top-right corner",
          "resizeBottomLeft": "Resize panel from the bottom-left corner"
        },
        "filters": {
          "label": "Filter by category",
          "all": "All"
        },
        "views": {
          "label": "View",
          "grid": "Grid view",
          "tree": "Tree view"
        },
        "emptyState": "Enhance or regenerate your model. New Variations will appear here.",
        "uploaded": "Uploaded",
        "menu": {
          "created": "Created: {{date}}",
          "setAsMain": "Set as main",
          "delete": "Delete"
        },
        "notifications": {
          "setAsMainSuccess": "\"{{name}}\" set as main successfully",
          "setAsMainError": "Failed to set variation as main. Please try again.",
          "deleteSuccess": "\"{{name}}\" deleted successfully",
          "deleteError": "Failed to delete variation. Please try again."
        }
      },
      "assist": {
        "heading": "Request for Designer Assistance",
        "placeholderDescription": "Get help from a real designer whenever you need it",
        "form": {
          "title": {
            "label": "Title",
            "placeholder": "Type here..."
          },
          "description": "Description",
          "budget": "Budget",
          "resell": "I allow the designer to sell Project results on the marketplace",
          "terms": {
            "agree": "I agree with the ",
            "link": "Terms and Conditions"
          },
          "submit": "Post a Project",
          "loadSoftwareError": "Failed to load 3D software",
          "submitError": "Something went wrong, please try again"
        },
        "deadline": {
          "label": "Deadline",
          "noFixed": "No fixed deadline"
        },
        "software": {
          "label": "3D Software",
          "placeholder": "Select 3D Software"
        },
        "references": {
          "label": "Visual references",
          "note": "We'll share the inputs used. You can also add references.",
          "untitledModel": "Untitled model",
          "dropzone": {
            "title": "Drag reference images here",
            "or": "or",
            "browse": "Browse"
          },
          "errors": {
            "uploadFailed": "Your file failed to attach. Please try again or contact our support",
            "onlyImages": "Only image files can be attached.",
            "tooBig": "Attachment is too big, please try to not exceed 100MBs.",
            "duplicate": "You cannot attach file with the same filename"
          }
        },
        "posted": {
          "title": "Request submitted",
          "description": "Your project has been posted to the open list for freelance designers. You'll be notified when someone applies",
          "cta": "Go to My 3D Projects"
        }
      }
    }
  },
  "shared": {
    "aiEngine": {
      "label": "AI Engine",
      "disabledTooltip": "Not available for this settings combination"
    },
    "polyCount": {
      "label": "Polycount",
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "polygonType": {
      "label": "Polygon Type",
      "quad": "Quad",
      "triangular": "Triangular"
    },
    "placeholder": {
      "comingSoon": "Coming soon"
    },
    "subscribersOnly": {
      "title": "For Subscribers Only",
      "simultaneousGenerationsTitle": "Multiple simultaneous generations are available to Subscribers only",
      "getSubscription": "Get Subscription"
    },
    "uploadModel": {
      "uploading": "Uploading...",
      "upload": "Use your 3D Model"
    },
    "shareContent": {
      "embedButtonLabel": "Embed this 3D Model"
    },
    "generateButton": {
      "inProgressTooltip": "Another generation is currently in progress. This action will be available once it has completed.",
      "limitReachedTooltip": "You've reached the maximum number of active generations. This action will be available once one is complete.",
      "sameSettingsTooltip": "This generation is already in progress. Change any settings to start another generation.",
      "genericError": "Generation failed. Please try again."
    },
    "privateMode": {
      "label": "Private Mode",
      "tooltip": "In Private Mode, only you can view and share the model. If Private Mode is not enabled, the model may be displayed in the community gallery, where other users can view and remix it."
    },
    "actionSelector": {
      "tabs": {
        "singleImage": "Single Image",
        "multiView": "Multi-View",
        "multiViewTooltip": "Upload the same object from several angles for a more accurate 3D model. The front view is required.",
        "image": "Image",
        "text": "Text"
      },
      "textInstructions": {
        "maxCharacters": "Maximum {{maxLength}} characters allowed"
      },
      "imageUploader": {
        "multiView": {
          "required": "Required",
          "title": "Multi-view image upload",
          "upload": "Upload {{view}} view image",
          "remove": "Remove {{view}} view image",
          "preview": "{{view}} view preview",
          "views": {
            "front": "Front",
            "left": "Left",
            "right": "Right",
            "back": "Back",
            "top": "Top",
            "bottom": "Bottom",
            "leftFront": "Left front",
            "rightFront": "Right front"
          }
        },
        "uploadPrompt": {
          "dropHere": "Drop your image here or",
          "browse": "browse",
          "fileTypes": "PNG, JPG, WEBP"
        },
        "pasteUrl": {
          "placeholder": "Image URL",
          "upload": "Upload image"
        },
        "preview": {
          "edit": "Edit this image"
        },
        "ideation": {
          "search": "Search Image",
          "create": "Create Image",
          "edit": "Edit Image"
        }
      }
    },
    "composer": {
      "placeholder": "Describe the object and view (e.g., electric sports car, front 3/4 view)",
      "upload": "Upload image"
    },
    "dccNotification": {
      "connecting": "Connecting plugin...",
      "sending": "Sending 3D Model to {{name}}...",
      "success": "3D Model is sent to {{name}}",
      "pluginNotRunning": {
        "title": "Plugin is not running",
        "descriptionWithName": "Make sure your DCC is open and the plugin is installed and running for {{name}}.",
        "description": "Make sure your DCC is open and the plugin is installed and running."
      },
      "dccBusy": {
        "title": "DCC is busy",
        "description": "It's still processing a previous import. Please try again in a moment."
      },
      "error": {
        "title": "Something went wrong",
        "description": "There was a problem sending your model. Please try again."
      }
    },
    "deleteConfirmModal": {
      "header": "Delete {{itemType}}?",
      "submit": "Delete",
      "cancel": "Cancel",
      "bodyNamed": "\"{{itemName}}\" will be permanently deleted. This action cannot be undone.",
      "bodyGeneric": "This {{itemType}} will be permanently deleted. This action cannot be undone.",
      "itemTypes": {
        "item": "item",
        "model": "model",
        "variation": "variation",
        "comment": "comment",
        "reply": "reply",
        "image": "image"
      }
    },
    "exportNotification": {
      "queued": {
        "title": "The file has been added to the queue.",
        "description": "Your export will start shortly."
      },
      "preparing": {
        "title": "Preparing your file for download."
      },
      "error": {
        "title": "Something went wrong",
        "description": "We couldn't complete the export. Please try again."
      }
    }
  },
  "leftSide": {
    "generate": {
      "generate": "Generate 3D Model",
      "regenerate": "Regenerate 3D Model",
      "generated": "Generated",
      "generating": "Generating..."
    },
    "modelSettings": {
      "promptPlaceholder": "Describe what you want to create"
    },
    "useCase": {
      "title": "Use case",
      "options": {
        "standard": {
          "title": "Standard",
          "description": "Good for most cases. Balanced quality and polygon count with PBR textures."
        },
        "hero": {
          "title": "Hero asset",
          "description": "Maximum quality. Dense quad mesh with full PBR - ideal for high quality assets."
        },
        "prop": {
          "title": "Prop asset",
          "description": "Game-ready prop with medium polygon count."
        },
        "threeDPrint": {
          "title": "3D print",
          "description": "High density triangulated mesh for 3D printing with basic material."
        },
        "shapeOnly": {
          "title": "Shape only",
          "description": "High density mesh with no textures. Ideal for validating geometry and surface detail."
        },
        "lowPoly": {
          "title": "Low Poly",
          "description": "Low polygon count mesh with PBR textures."
        }
      }
    },
    "material": {
      "label": "Material",
      "pbr": "PBR",
      "basic": "Basic",
      "geometryOnly": "Geometry only",
      "geometry": "Geometry"
    },
    "extraQuality": {
      "label": "Extra Quality",
      "badge": "New",
      "hint": "2x usage, longer generation"
    },
    "smartLowPoly": {
      "label": "Smart low poly",
      "collapsedLabel": "Low poly"
    },
    "advancedSettings": {
      "trigger": "Advanced settings"
    },
    "polyCount": {
      "label": "Polycount",
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "polygonType": {
      "label": "Polygon Type",
      "quad": "Quad",
      "triangular": "Triangular"
    },
    "aiEngine": {
      "label": "AI Engine"
    },
    "actionPreview": {
      "title": "Input"
    }
  },
  "header": {
    "modelSettings": "Generate 3D Model",
    "viewer": "3D Model"
  },
  "community": {
    "card": {
      "remix": "Remix {{title}}",
      "remixBy": "Remix {{title}} by {{username}}"
    }
  },
  "imageGallery": {
    "card": {
      "open": "Open {{title}}",
      "edit": "Edit {{title}}",
      "download": "Download {{title}}",
      "generate3d": "Generate 3D",
      "generate3dFor": "Generate a 3D model from {{title}}"
    },
    "categories": {
      "all": "All",
      "aircraft": "Aircraft",
      "animals": "Animals",
      "architectural": "Architectural",
      "exterior": "Exterior",
      "interior": "Interior",
      "car": "Car",
      "character": "Character",
      "military": "Military",
      "furniture": "Furniture",
      "food": "Food",
      "plant": "Plant",
      "science": "Science",
      "space": "Space",
      "sports": "Sports",
      "vehicle": "Vehicle",
      "watercraft": "Watercraft"
    },
    "modal": {
      "ariaLabel": "Image {{title}}",
      "previous": "Previous image",
      "next": "Next image",
      "edit": "Edit",
      "download": "Download",
      "createdBy": "Created by {{username}}",
      "prompt": "Prompt",
      "copyPrompt": "Copy prompt",
      "expandPrompt": "Show full prompt",
      "collapsePrompt": "Collapse prompt",
      "generationSettings": "Generation settings",
      "settings": {
        "reference": "Reference",
        "baseModel": "Base model",
        "aspectRatio": "Aspect ratio",
        "style": "Style",
        "resolution": "Image resolution",
        "seed": "Seed"
      },
      "similarImages": "Similar Images"
    },
    "downloadFailed": "Download failed. Please try again.",
    "loadError": "Failed to load images.",
    "searchPlaceholder": "Search",
    "moreCategories": "More",
    "empty": {
      "title": "No images found matching your criteria",
      "description": "Try adjusting your search or selecting different filters",
      "clearFilters": "Clear Filters"
    }
  },
  "commentsModal": {
    "ariaLabel": "Comments",
    "placeholder": "Feel free to share your thoughts here.",
    "replyPlaceholder": "Write your reply here",
    "post": "Post",
    "reply": "Reply",
    "delete": "Delete",
    "deleteCommentBy": "Delete comment by {{username}}",
    "deleteReplyBy": "Delete reply by {{username}}",
    "relativeTime": {
      "year": "{{count}} y",
      "month": "{{count}} mo",
      "week": "{{count}} w",
      "day": "{{count}} d",
      "hour": "{{count}} h",
      "minute": "{{count}} min",
      "second": "{{count}} s"
    },
    "hide": "Hide",
    "creatorBadge": "Creator of the model",
    "commentsCount": "{{count}} Comment",
    "commentsCount_plural": "{{count}} Comments",
    "repliesCount": "{{count}} Reply",
    "repliesCount_plural": "{{count}} Replies",
    "empty": "No comments yet. Be the first to share your thoughts.",
    "loadError": "Failed to load comments.",
    "submitError": "Something went wrong. Please try again.",
    "limitReached": "You've reached the commenting limit for now. Please try again later.",
    "loginPrompt": "Log in to join the conversation.",
    "login": "Log in"
  },
  "imageComments": {
    "creatorBadge": "Creator of the image",
    "empty": "No comments yet"
  },
  "like": {
    "likeModel": "Like {{title}}",
    "unlikeModel": "Unlike {{title}}",
    "like": "Like",
    "unlike": "Unlike",
    "dailyLimitReached": "You have reached today's like limit. Try again tomorrow."
  },
  "likers": {
    "title": "{{count}} like",
    "title_plural": "{{count}} likes",
    "openList": "See who liked this model",
    "close": "Close",
    "relativeTime": {
      "day": "{{count}}d ago",
      "hour": "{{count}}h ago",
      "minute": "{{count}}m ago",
      "second": "{{count}}s ago"
    }
  },
  "footerActions": {
    "delete": "Delete",
    "share": "Share",
    "creator": {
      "createdBy": "Created by {{username}}"
    },
    "export": {
      "label": "Export"
    },
    "dccBridge": {
      "tooltip": "Install and run the plugin first to send models to the corresponding DCC software",
      "comingSoon": "Coming soon",
      "downloadPluginButton": "Download Plugin",
      "guide": "Guide"
    },
    "sendTo": {
      "label": "Send to",
      "labelWithName": "Send to {{name}}",
      "needHelp": "Need help?",
      "setupGuide": "See setup guide",
      "downloadPlugin": "Download plugin",
      "step1": "Download and install the plugin",
      "step2": "Launch your DCC and make sure the plugin is running",
      "step3": "Send your model directly to your DCC."
    },
    "modelTitle": {
      "updateSuccess": "Model title updated successfully.",
      "updateError": "Failed to update model title."
    }
  },
  "viewer": {
    "banner": {
      "phase": {
        "queued": "Waiting in queue...",
        "analyzing": "Analyzing your input...",
        "generating": "Generating your 3D model...",
        "refining": "Refining details...",
        "finalizing": "Finalizing your 3D model..."
      },
      "phaseTimeLeft": {
        "minutes": "~{{minutes}} min left",
        "lessThanMinute": "Less than 1 min left"
      },
      "slotsNotice": {
        "highlight": "{{available}} of {{total}} simultaneous generations",
        "rest": "are still available with your plan. Keep creating or editing your models!"
      },
      "unlockFeatures": {
        "title": "Unlock Advanced Features",
        "cta": "Get Subscription",
        "simultaneousGenerations": "Up to 5 generations at the same time",
        "queuePriority": "Priority in the queue",
        "privateMode": "Private mode",
        "dccBridge": "DCC Bridge",
        "modelDownloads": "3D Model Downloads"
      },
      "initial": "Your 3D Model will appear here",
      "generatingTitle": "Generating your 3D model",
      "generatingDescription": "This may take a few minutes. You'll see an indicator in the top menu when it's ready. We'll also send you an email so you don't miss it.",
      "loadingTitle": "Loading 3D model",
      "uploadingTitle": "Uploading your 3D model...",
      "uploadingDescription": "This may take a moment. Complex models may take longer to load.",
      "cleverPush": {
        "prompt": "Get notified even when you switch tabs",
        "allow": "Allow Browser Notifications"
      },
      "relatedProducts": {
        "title": "You may also like",
        "viewMore": "View more in Marketplace"
      }
    },
    "errorBanner": {
      "tryAgain": "{{action}} Again",
      "title": "Something went wrong",
      "description": "We couldn't complete this action. Try adjusting settings, simplifying your input, or checking references.",
      "errorId": "ERROR ID",
      "reason": "REASON",
      "message": "MESSAGE",
      "providerCode": "PROVIDER CODE"
    },
    "modelReadyToaster": {
      "message": "Your model is ready! Now explore Enhance tools to refine and customize it.",
      "dontShowAgain": "Don't show again"
    },
    "remixNotice": {
      "title": "You are in Remix Mode",
      "description": "Adjust settings, regenerate, and enhance this 3D model to create your own version. New creations will be saved to your library.",
      "tag": "Remix Mode"
    },
    "termsOfServiceNotice": {
      "lead": "Please note that by continuing to use CGTrader AI, you agree to the",
      "link": "CGTrader AI Terms of Service"
    },
    "canvas": {
      "failedToStart": "Failed to start"
    },
    "environment": {
      "title": "Environment settings",
      "strength": "Strength",
      "rotation": "Rotation",
      "uploadHdri": "Upload HDRI",
      "surrounding": "Surrounding",
      "showDefaultHdri": "Show Default HDRI",
      "showHdri": "Show HDRI",
      "uploadFailed": "HDRI upload failed. Please try again.",
      "added": "\"{{label}}\" added to surroundings."
    },
    "sidebar": {
      "lighting": "Lighting (L)",
      "toggleGrid": "Toggle grid (G)",
      "autoRotate": "Toggle auto rotate (R)",
      "resetCamera": "Reset camera (F)"
    },
    "renderMode": {
      "pbr": "PBR (M)",
      "clay": "Clay (C to cycle)",
      "baseColor": "Base color only (C to cycle)",
      "roughness": "Roughness only (C to cycle)",
      "normals": "Normals only (C to cycle)",
      "metalness": "Metalness only (C to cycle)",
      "segmentation": "Segmentation (C to cycle)",
      "wireframe": "Wireframe (W)"
    },
    "animationPlayer": {
      "play": "Play animation",
      "pause": "Pause animation",
      "timeline": "Animation timeline",
      "progress": "{{current}} of {{total}}"
    },
    "modelDetails": {
      "faces": "Faces",
      "vertices": "Vertices",
      "aiEngine": "AI Engine",
      "extraQuality": "Extra",
      "lowPoly": "Low poly",
      "polycount": "Polycount",
      "polygonType": "Polygon Type",
      "material": "Material",
      "true": "True",
      "false": "False",
      "materialBasic": "Basic",
      "materialGeometryOnly": "Geometry Only"
    }
  },
  "signIn": {
    "header": {
      "signupTitle": "Create an account to get started",
      "cgdreamSignupTitle": "Sign in to continue on CGTrader AI",
      "loginTitle": "Welcome back",
      "signupSubtitle": "We will email you a 6-digit code, so you can sign in without having to create the password.",
      "loginSubtitle": "Log in to keep creating, designing and downloading."
    },
    "auth": {
      "divider": "or",
      "optIn": "Get product updates, community news and offers."
    },
    "email": {
      "label": "Email",
      "placeholder": "john@email.com",
      "ariaLabel": "Email address"
    },
    "footer": {
      "submit": "Continue",
      "haveAccount": "Have an account?",
      "noAccount": "Don't have an account?",
      "login": "Log in",
      "signup": "Sign Up"
    },
    "terms": {
      "prefix": "By continuing I agree to the",
      "termsLink": "General Terms & Conditions",
      "and": "and",
      "privacyLink": "Privacy Policy."
    },
    "code": {
      "title": "Check your email",
      "subtitlePrefix": "We've sent a 6-digit code to",
      "yourEmail": "your email",
      "invalidCode": "Invalid access code. Please try again.",
      "resendPrompt": "Didn't receive the email?",
      "resendAction": "Click to resend",
      "digitAriaLabel": "Digit {{index}}"
    },
    "success": {
      "title": "You are in!",
      "loginSubtitle": "You are logged in. Pick up where you left off!",
      "signupSubtitle": "Account created. Generate your first 3D model!"
    },
    "modal": {
      "loginAriaLabel": "Log in to CGTrader AI",
      "signupAriaLabel": "Sign up to CGTrader AI",
      "successAriaLabel": "You are in"
    },
    "password": {
      "link": "Log in with password instead",
      "emailLabel": "Email or Username",
      "title": "Log in with password",
      "subtitle": "Enter your email and password to continue.",
      "passwordLabel": "Password",
      "forgotPassword": "Forgot password?",
      "submit": "Log in",
      "back": "Back",
      "showPassword": "Show password",
      "hidePassword": "Hide password",
      "genericError": "Something went wrong. Please try again later.",
      "requiredNotice": "Please also enter your password to complete the 2FA.",
      "twoFaTitle": "Enter your login verification code",
      "twoFaDescription": "The verification code was sent to the email address you use to log in to your CGTrader account",
      "twoFaVerify": "Verify",
      "twoFaCodeLabel": "Verification code"
    }
  },
  "threeDModelPicker": {
    "title": "Select or upload 3D Model",
    "purchasesHeading": "My Purchases",
    "searchPlaceholder": "Search 3D Model",
    "uploadTile": "Upload 3D Model",
    "submit": "Use Selected 3D Model",
    "error": "We couldn't load your purchased models. Please try again.",
    "notFound": "No purchased models match \"{{keywords}}\".",
    "cardLabel": "Select {{title}}",
    "cardUnsupportedLabel": "{{title}} has no file the viewer can open",
    "openError": "Could not open this 3D model. Please try again.",
    "empty": {
      "title": "You don't have any purchased models yet to choose from",
      "description": "Upload your own model or explore the Marketplace.",
      "searchMarketplace": "Search in Marketplace"
    }
  }
}
